export const SET_BOOKINGLINES = 'SET_BOOKINGLINES';
export const FAILED_GET_BOOKINGLINES = 'FAILED_GET_BOOKINGLINES';
export const SUCCESS_CREATE_BOOKING_LINE = 'SUCCESS_CREATE_BOOKING_LINE';
export const FAILED_CREATE_BOOKING_LINE = 'FAILED_CREATE_BOOKING_LINE';
export const SUCCESS_UPDATE_BOOKING_LINE = 'SUCCESS_UPDATE_BOOKING_LINE';
export const FAILED_UPDATE_BOOKING_LINE = 'FAILED_UPDATE_BOOKING_LINE';
export const SUCCESS_DELETE_BOOKING_LINE = 'SUCCESS_DELETE_BOOKING_LINE';
export const FAILED_DELETE_BOOKING_LINE = 'FAILED_DELETE_BOOKING_LINE';
export const SUCCESS_DELETE_BOOKING_LINES = 'SUCCESS_DELETE_BOOKING_LINES';
export const FAILED_DELETE_BOOKING_LINES = 'FAILED_DELETE_BOOKING_LINES';
export const SUCCESS_CALC_COLLECTED_LINE = 'SUCCESS_CALC_COLLECTED_LINE';
export const FAILED_CALC_COLLECTED_LINE = 'FAILED_CALC_COLLECTED_LINE';
export const RESET_FLAG_LINES = 'RESET_FLAG_LINES';
export const SUCCESS_GET_BOOKING_LINES_CNT = 'SUCCESS_GET_BOOKING_LINES_CNT';
export const FAILED_GET_BOOKING_LINES_CNT = 'FAILED_GET_BOOKING_LINES_CNT';
export const SUCCESS_GET_LINES_BULK = 'SUCCESS_GET_LINES_BULK';
export const FAILED_GET_LINES_BULK = 'FAILED_GET_LINES_BULK';
export const SUCCESS_EDIT_LINES_BULK = 'SUCCESS_EDIT_LINES_BULK';
export const FAILED_EDIT_LINES_BULK = 'FAILED_EDIT_LINES_BULK';



// WEBPACK FOOTER //
// ./src/state/constants/bookingLineConstants.js